import { useRef, useState } from "react";
import { LuBanknote, LuCheck, LuChefHat, LuClock } from "react-icons/lu";
import { TpvDialog } from "../../../components/TpvDialog";
import { formatMoney } from "../../../utils/pricing";

export const OrderSent = ({ flow, onPayNow, onPayLater, onNew, onDismiss }) => {
  const [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const pending = useRef(false);
  const later = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      await onPayLater();
    } catch (e) {
      setError(
        e.message || "No se pudo preparar la siguiente venta. Reintenta.",
      );
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  const number = flow.order.displayNumber || flow.order.number;
  const choosing = flow.step === "choice";
  const title = choosing
    ? `Pedido #${number} enviado a cocina`
    : `Pedido #${number} en cocina`;
  return (
    <TpvDialog
      title={title}
      headerHidden
      hideClose
      onClose={choosing ? onDismiss : onNew}
      busy={busy}
      className="tpvOrderSent"
    >
      <div className="tpvOrderSentBody">
        <span className={`tpvOrderSentIcon ${choosing ? "is-success" : ""}`}>
          {choosing ? (
            <LuCheck aria-hidden="true" />
          ) : (
            <LuChefHat aria-hidden="true" />
          )}
        </span>
        <h2>{title}</h2>
        <p>
          {choosing
            ? `${flow.count} ${flow.count === 1 ? "artículo" : "artículos"} · ${formatMoney(flow.total)}`
            : [flow.customerName, flow.deliveryName]
                .filter(Boolean)
                .join(" · ")}
        </p>
        {error && <p role="alert">{error}</p>}
        {choosing ? (
          <>
            <h3>¿Cuándo se cobra?</h3>
            <div className="tpvOrderSentChoices">
              <button
                className="tpvPrimary"
                type="button"
                disabled={busy}
                onClick={onPayNow}
              >
                <LuBanknote aria-hidden="true" />
                COBRAR AHORA
              </button>
              <button type="button" disabled={busy} onClick={later}>
                <LuClock aria-hidden="true" />
                {busy ? "PREPARANDO…" : "COBRAR MÁS TARDE"}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="tpvOrderSentPending">
              <strong>
                {flow.homeDelivery ? "COBRO POR REPARTIDOR" : "PAGO PENDIENTE"}
              </strong>
              <b>{formatMoney(flow.total)}</b>
            </div>
            <button className="tpvPrimary" type="button" onClick={onNew}>
              NUEVO PEDIDO
            </button>
          </>
        )}
      </div>
    </TpvDialog>
  );
};
